import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  Card, CardBody,
  Container, Col, Row, Button,
  Nav, NavItem, NavLink,
  TabContent, TabPane,
  Table
} from "reactstrap";

import classnames from "classnames";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


import { createSelector } from "reselect";
import { getPart, publish } from "../../../slices/thunks";
import { bodyTypeData, enginePower, engineTypes, fuelTypes, manufacturers, models } from "../../../common/data/olxCategories";

import ImagePreview from "../../../Components/ImagePreview";
import NoResults from "../../Vehicles/NoResults";
import VehicleModal from "../Modals/VehicleModal";

const VehicleDetails = () => {
  document.title =  "Detalji o vozilu";
  const user = JSON.parse(sessionStorage.getItem("authUser"));
  const isAdmin = user.role == "Admin" ? true : false;

  const [vehicleDetails, setVehicleDetails] = useState(JSON.parse(sessionStorage.getItem("vehicleDetails")));

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectProperties = createSelector(
    (state) => state.Vehicle,
    (state) => ({
      currentVehicle: state.vehicleDetails,
  }));

  const { currentVehicle } = useSelector(selectProperties);

  const [editModal, setEditModal] = useState(false);
  const toggleEditModal = useCallback(() => {
    setEditModal(!editModal);
  }, [editModal]);

  useEffect(() => {
    if (currentVehicle !== "") setVehicleDetails(currentVehicle);
  }, [currentVehicle]);

  const [customActiveTab, setCustomActiveTab] = useState("1");
  const toggleCustom = (tab) => {
    setCustomActiveTab(tab);
  };

  const brand = manufacturers.find(m => m.value === vehicleDetails.brand);  
  const model = models.find(b => b.parentValue === brand.value && b.value === vehicleDetails.model);
  const vehicleName = brand.label + " " + model.label;
  const engine = enginePower.find(item => item.value === vehicleDetails.engine);
  const fuel = fuelTypes.find(f => f.value === vehicleDetails.engineFuel);
  const bodyType = bodyTypeData.find(b => b.value === vehicleDetails.bodyType);
  const tag = engineTypes.find(e => e.value === vehicleDetails.engineTag);
  
  const onRowClick = (part) => {
    sessionStorage.setItem("partDetails", JSON.stringify(part));
    dispatch(getPart(part.id));
    navigate("/part-details");
  };
  const handlePublishClick = (vehicleId) => {
    dispatch(publish({id: vehicleId, isVehicle: true}))
  };

  const handleCopyToClipboard = async () => {
    await navigator.clipboard.writeText("https://olx.ba/artikal/" + vehicleDetails.listingId);
    toast.info("Link kopiran.");
  };
  const calculateProfit = () => {
    if(vehicleDetails.purchasePrice == null || vehicleDetails.taxPrice == null || vehicleDetails.totalSoldPartsPrice == null) return "Nepotpuni podaci.";
    return vehicleDetails.totalSoldPartsPrice - (vehicleDetails.purchasePrice + vehicleDetails.taxPrice) + " KM";
  };
  
  return (
    <div className="page-content">
      <Container fluid>
        <ToastContainer closeButton={false} limit={1} />
        <VehicleModal show={editModal} onCloseClick={toggleEditModal} isEdit={true} vehicleDetails={vehicleDetails} />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <Row className="gx-lg-5">
                  <Col xl={4} md={8} className="mx-auto">
                    <ImagePreview images={vehicleDetails.images} />                                       
                  </Col>
                  <Col xl={8}>
                    <div className="mt-xl-0 mt-5">
                      <div className="d-flex">
                        <div className="flex-grow-1 gap-3">
                          <div className="hstack gap-3 flex-wrap">
                            <h2>{vehicleDetails.displayId + " " + vehicleName}</h2> 
                            <h4>
                              {vehicleDetails.listingId != null && (<span className="mx-1 badge rounded-pill border border-info text-uppercase text-info"> OLX </span>)}
                            </h4>
                          </div>
                        </div>
                        <div className="hstack gap-2 justify-content-end d-print-none">
                          <Button id="edit-btn" color="dark" outline onClick={() => {toggleEditModal();}}> <i className="ri-pencil-fill"></i> </Button>
                        </div>
                      </div>
                      {vehicleDetails.listingId != null && (
                        <div className="mt-4">
                          <span className="mx-2 fw-semibold fs-16 text-uppercase">Olx Link:</span>
                          <span className="mx-2 fw-semibold fs-16">{"https://olx.ba/artikal/" + vehicleDetails.listingId}</span>
                          <span className="btn btn-icon btn-outline-info mx-2 text-primary" style={{ cursor: "pointer" }} onClick={handleCopyToClipboard}><i className="ri-clipboard-line fs-16" /></span>
                        </div>)}
                      {(isAdmin && vehicleDetails.listingId == null) && (
                        <div className="hstack justify-content-end">
                          <Button color='primary' outline onClick={() => {handlePublishClick(vehicleDetails.id)}}>Objavi na OLX</Button>
                        </div>
                      )}

                      <div className="product-content mt-5">
                        <Nav tabs className="nav-tabs-custom nav-success">
                          <NavItem>
                            <NavLink style={{ cursor: "pointer" }} className={classnames({ active: customActiveTab === "1" })}
                              onClick={() => { toggleCustom("1"); }} > Detalji </NavLink>
                          </NavItem>
                          {isAdmin && (
                            <NavItem>
                              <NavLink style={{ cursor: "pointer" }} className={classnames({ active: customActiveTab === "2" })}
                                onClick={() => { toggleCustom("2"); }} > Finansije </NavLink>
                            </NavItem>
                          )}
                        </Nav>
                        <TabContent id="nav-tabContent" className="border border-top-0 p-4" activeTab={customActiveTab}>
                          <TabPane id="nav-speci" tabId="1" >
                            <div className="table-responsive">
                              <table className="table mb-0">
                                <tbody>
                                  <tr>
                                    <th scope="row" style={{ width: "200px" }}> Broj šasije: </th>
                                    <td>{vehicleDetails.vin}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row" style={{ width: "200px" }}> Kilometraža: </th>
                                    <td>{vehicleDetails.mileage}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row"> Motor: </th>
                                    <td>{ engine.label + " " + fuel.label}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row"> Snaga motora: </th>
                                    <td>{ vehicleDetails.enginePower == null ? "N/A" : vehicleDetails.enginePower + " kW"}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row"> Oznaka motora: </th>
                                    <td>{ tag.label }</td>
                                  </tr>
                                  <tr>
                                    <th> Godina: </th>
                                    <td>{ vehicleDetails.productionYear == null ? "N/A" : vehicleDetails.productionYear }</td>
                                  </tr>
                                  <tr>
                                    <th>Boja vozila: </th>
                                    <td>{ vehicleDetails.color == null ? "N/A" : vehicleDetails.color}</td>
                                  </tr>
                                  <tr>
                                    <th>Vrsta: </th>
                                    <td>{ bodyType.label }</td>
                                  </tr>
                                </tbody>                                
                              </table>
                            </div>                            
                          </TabPane>
                          {isAdmin && (
                            <TabPane id="nav-detail" tabId="2">
                          <div className="table-responsive">
                          <table className="table mb-0">
                            <tbody>
                              <tr>
                                <th scope="row"> Cijena/Transport: </th>
                                <td>{ vehicleDetails.purchasePrice == null ? "N/A" : vehicleDetails.purchasePrice + " KM"}</td>
                              </tr>
                              <tr>
                                <th scope="row" style={{ width: "200px" }}> Dobavljač: </th>
                                <td>{vehicleDetails.sellerName== null ? "N/A" : vehicleDetails.sellerName}</td>
                              </tr>
                              <tr>
                                <th scope="row"> Carina/Porez: </th>
                                <td>{ vehicleDetails.taxPrice == null ? "N/A" : vehicleDetails.taxPrice + " KM"}</td>
                              </tr>
                              <tr>
                                <th scope="row"> Poreznik: </th>
                                <td>{ vehicleDetails.taxerName == null ? "N/A" : vehicleDetails.taxerName }</td>
                              </tr>
                              <tr>
                                <th scope="row"> Ukupna vrijednost dijelova: </th>
                                <td>{ vehicleDetails.totalPartsPrice == null ? "N/A" : vehicleDetails.totalPartsPrice + " KM" }</td>
                              </tr>
                              <tr>
                                <th scope="row"> Prodano: </th>
                                <td>{ vehicleDetails.totalSoldPartsPrice == null ? "N/A" : vehicleDetails.totalSoldPartsPrice + " KM" }</td>
                              </tr>
                              <tr>
                                <th scope="row"> Presjek: </th>
                                <td>{calculateProfit()}</td>
                              </tr>
                            </tbody>                                
                          </table>
                        </div> 
                          </TabPane>
                          )}
                        </TabContent>
                      </div>

                      <div className="mt-4 text-muted">
                        <h4 className="fs-13">Opis :</h4>
                        <p className="">{ vehicleDetails.description === null ? "Za ovaj artikal nije unesen opis." : vehicleDetails.description}</p>
                      </div>
                    </div>
                  </Col>
                </Row>

                
                
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Card>
        <CardBody className="pt-0">
                        {(!vehicleDetails.parts || !vehicleDetails.parts.length) ? ( <NoResults /> ) : 
                            (<div className="table-responsive table-card mb-1">
                                <Table hover className="align-middle table-nowrap">
                                    <thead className="table-light text-muted text-uppercase align-content-center">
                                        <tr>
                                            <th>Id broj</th>
                                            <th>Naziv</th>
                                            <th>Kataloški broj</th>
                                            <th>Lokacija</th>
                                            <th>Status</th>
                                            <th>OLX</th>
                                            <th>Cijena</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {vehicleDetails.parts.map(part => (
                                        <tr key={part.id}>
                                            <td style={{width: 50}} onClick={() => onRowClick(part)}>
                                                <h5 className="fs-14 text-uppercase text-center mb-1">{part.displayId}</h5>
                                            </td>
                                            <td onClick={() => onRowClick(part)}>
                                                <div className="d-flex align-items-center">
                                                    <div className="flex-shrink-0 me-3">
                                                        <div className="bg-light rounded overflow-hidden" style={{width: 100, height: 80}}>
                                                            <img src={part.thumbnail} alt="img-thumbnail" className="d-block img-thumbnail" />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <h5 className="fs-14 mb-1">{part.name}</h5>
                                                    </div>
                                                </div>
                                            </td>
                                            <td onClick={() => onRowClick(part)}>
                                                <h5 className="fs-14 mb-1">{part.catalogNumber}</h5>
                                            </td>
                                            <td onClick={() => onRowClick(part)}><h5 className="fs-14 mb-1">{part.location}</h5></td>
                                            <td onClick={() => onRowClick(part)}>{ 
                                            part.status == 1 && (<span className="badge rounded-pill border border-success text-uppercase text-success"> Dostupno </span>)
                                            || part.status == 2 && (<span className="badge rounded-pill border border-danger text-uppercase text-danger"> Nedostupno </span>)
                                            || part.status == 3 && (<span className="badge rounded-pill border border-warning text-uppercase text-warning"> Na čekanju </span>) 
                                            || part.status == 4 && (<span className="badge rounded-pill border border-primary text-uppercase text-primary"> Prodano </span>)
                                            }</td>
                                            <td>
                                            {part.listingId != null && (
                                              <div className="hstack justify-content-start">
                                                <Button color='primary' outline onClick={() => {handleCopyToClipboard(part)}}><i className="ri-clipboard-line fs-14" /></Button>
                                              </div>)}
                                            </td>
                                            
                                                <td onClick={() => onRowClick(part)}>
                                                    <h5 className="fs-14 mb-1">{part.sellingPrice + " KM"}</h5>
                                                </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>)}
            </CardBody></Card>
      </Container>
    </div>
  );
};

export default VehicleDetails;
